import React from 'react';
import { Link } from 'react-router-dom';
import Photo from './Photo';
import { capSizes } from '../utils/pbImageUrl';
import { countPhotos, formatAlbumDates } from '../utils/imageScanner';

function AlbumCard({ album, link, priority }) {
  const dates = formatAlbumDates(album.date_from, album.date_to);
  const count = countPhotos(album.images.length);

  return (
    <Link
      to={link}
      className="reveal group relative block aspect-[4/5] overflow-hidden rounded-lg bg-base-200 transition-transform duration-200 active:scale-[0.98]"
    >
      <Photo
        cover
        src={album.cover_image_url}
        srcSet={album.cover_srcset}
        sizes={capSizes('(min-width: 1024px) 370px, 50vw')}
        alt={album.name}
        priority={priority}
        className="transition-transform duration-700 group-hover:scale-105"
      />
      <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-black/80 to-transparent p-3 pt-12 text-left text-white sm:p-4 sm:pt-16">
        <h2 className="text-base font-semibold leading-tight sm:text-lg">{album.name}</h2>
        <div className="mt-0.5 text-xs text-white/80 sm:text-sm">{dates ? `${dates} · ${count}` : count}</div>
      </div>
    </Link>
  );
}

export default AlbumCard;
